module.exports = __webpack_public_path__ + "img/score_right.bbd6d233.png";